import { StyleSheet } from 'react-native';
import { getBoxShadow } from 'src/helpers/style.helper';
import { Brand, Neutrals } from 'src/theme-v2/colors';
import { Stroke } from 'src/theme-v2/stroke';

export const style = StyleSheet.create({
  dropdownContainer: {
    width: 160,
    borderRadius: 12,
    paddingTop: 4,
    overflow: 'hidden',
    backgroundColor: Neutrals.main.White,
    shadowColor: Neutrals.main.Black,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 43,
  },
  actionsWrapper: {
    gap: 6,
    paddingBottom: 6,
  },
  action: {
    flex: 1,
    width: '100%',
    minHeight: 40,
    maxHeight: 54,
    paddingVertical: 12,
    paddingHorizontal: 12,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 8,
    borderBottomWidth: 1,
    borderBottomColor: Stroke.StrokeColor.StrokeColorNeutral,
  },
  actionLast: {
    flex: 1,
    width: '100%',
    minHeight: 40,
    maxHeight: 54,
    paddingVertical: 12,
    paddingHorizontal: 12,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 8,
  },
  actionInner: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  // PressableHovered's own `style` prop only lands on its outer Pressable, not on the
  // inner View wrapping its children — so multi-child content needs its own row wrapper.
  actionContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  optionsTitleContent: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  actionIcon: {
    width: 22,
    height: 22,
  },
  actionText: {
    flex: 1,
    fontWeight: 700,
    fontSize: 12,
    lineHeight: 16,
    color: Neutrals.neutralGreys.GreyNatural850,
    maxWidth: 136,
  },
  actionTextDelete: {
    fontWeight: 700,
    fontSize: 12,
    lineHeight: 16,
    color: Neutrals.neutralGreys.GreyNatural850,
    maxWidth: 136,
  },
  iconCounter: {
    width: 17,
    height: 17,
    borderRadius: 21,
    justifyContent: 'center',
    alignItems: 'center',
    ...getBoxShadow({
      offsetX: 2,
      offsetY: 2,
      blurRadius: 4,
      color: Brand.water.Water100,
    }),
  },
  countText: {
    fontWeight: 700,
    fontSize: 12,
    lineHeight: 14,
    color: Brand.water.Water500,
    minWidth: 30,
    textAlign: 'center',
  },
  selectedButton: {
    position: 'absolute',
    zIndex: 3,
    borderRadius: 20,
    padding: 6,
    backgroundColor: Neutrals.main.White,
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 13,
  },
  icon: {
    width: 18,
    height: 18,
    color: Neutrals.main.White,
  },
  positionRight: {
    left: -10,
    top: -13,
  },
  positionLeft: {
    right: -10,
    top: -13,
  },
  buttonHover: {
    backgroundColor: Neutrals.coldGreys.GreyCold050,
  },
  scrollViewVertical: {
    flex: 1,
    maxHeight: 300,
  },
  optionsTitle: {
    flex: 1,
    width: '100%',
    paddingVertical: 12,
    paddingHorizontal: 12,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 12,
    borderBottomWidth: 1,
    borderBottomColor: Stroke.StrokeColor.StrokeColorNeutral,
  },
});
